export default "__VITE_ASSET__CWKXj$4c__"